module.exports = __webpack_public_path__ + "img/443-0918d0.png";